import { defaultRegionInfoProvider } from "./endpoints";
export var ClientSharedValues = {
  apiVersion: "2014-06-30",
  disableHostPrefix: false,
  logger: {},
  regionInfoProvider: defaultRegionInfoProvider,
  signingName: "cognito-identity"
};